import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Flex, Form, message, Row, Col, Checkbox } from "antd";
import {
  CustomInput,
  CustomDynamicSelect,
  CustomButton,
  CustomTitle,
  StatusCardNotification,
  CustomSelect,
  AddItemButton,
} from "../../components";
import { CloseOutlined, WarningFilled } from "@ant-design/icons";
import deleteRedIcon from "../../assets/images/delete-red.svg";
import { useToken, appHelper } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { getCouriersDDL } from "../../common/utils/dropDown";
import BackArrow from "../../assets/images/back-arrow.svg";
import {
  DeleteSettingCouriers,
  GetSettingCourierById,
} from "../../api's/settings";
import { LinkSettingsCourierAccount } from "../../api's/settings";
import { selectCouriersState } from "../../reudx-toolkit/slice/onboardingSlice";
import ReactFlagsSelect from "react-flags-select";
import CountryList from "country-list-with-dial-code-and-flag";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const SettingsTransportForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { capitalize } = appHelper();
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const [couriersDDL, setCouriersDDL] = useState([]);
  const [status, setStatus] = useState(null);
  const [courierName, setCourierName] = useState(null);
  const [instructions, setInstructions] = useState("");
  const state = useSelector(selectCouriersState);
  const [isEnabled, setIsEnabled] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [courierModal, setCourierModal] = useState(["Client ID"]);
  const [courierId, setCourierId] = useState(null);

  // add country code and flag [mahtab]
  // const [selectedCountryCode, setSelectedCountryCode] = useState("");
  // const countryOptions = CountryList.getAll().reduce((acc, country) => {
  //   acc[country.code] = ` ${country.name} ${country.dial_code}`;
  //   return acc;
  // }, {});

  const handleSelect = (isoCode, index) => {
    let previousArr = form.getFieldValue("contacts") || [];
    if (Array.isArray(previousArr) && previousArr.length > 0 && index > -1) {
      const updatedContacts = [...previousArr];
      updatedContacts[index] = {
        ...updatedContacts[index],
        phone_number: isoCode,
      };
      form.setFieldsValue({ contacts: updatedContacts });
    }
  };

  useEffect(() => {});

  // end country code and flag [mahtab]

  useEffect(() => {
    if (state) {
      if (state?.courierList && state?.courierList.length > 0) {
        setCouriersDDL(state.courierList);
        let obj = state.courierList.find((x) => x.id == id);
        if (obj) {
          setCourierName(obj?.title);
          setInstructions(obj?.instructions ? obj?.instructions : null);
          setCourierId(obj?.id);
          if (obj?.required_inputs && Array.isArray(obj?.required_inputs)) {
            setCourierModal(obj?.required_inputs);
          }
          if (
            obj?.is_enabled &&
            (obj?.is_zoom_logi_provider || obj.is_public)
          ) {
            setIsEnabled(false);
            setShowErrorMessage(false);
          } else if (!obj?.is_enabled) {
            setIsEnabled(false);
            setShowErrorMessage(true);
          } else {
            setIsEnabled(true);
            setShowErrorMessage(false);
          }
        }
      }
    }
  }, [state]);

  useEffect(() => {
    if (id) {
      GetSingleCourier();
    }
  }, [id]);

  const GetSingleCourier = () => {
    showSpin();
    GetSettingCourierById(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              form.setFieldsValue(resp?.credentials);
              // client_id: resp.client_id || "",
              // courier_id: resp.courier_id || null,
              // client_secret: resp.client_secret || "",
              //contacts : resp.contacts || [{ name: "", role: "", email: "", country_code: "", phone_number: "", is_primary_contact: false }]

              if (resp.contacts && resp.contacts.length > 0) {
                form.setFieldsValue({
                  contacts: resp.contacts,
                });
              }
              setStatus(resp.status);
              // console.log('res is : ',res)
              // setCourierName(resp.courier_name)
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  //OnSubmit form
  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = {
        ...form.getFieldsValue(),
      };
      if (id) {
        model.courier = id;
      }
      const countContacts =
        model?.contacts &&
        model?.contacts.filter((item) => item?.is_primary_contact === true);
      if (countContacts?.length === 1) {
        LinkCouriers(model);
      } else if (countContacts?.length < 1) {
        message.error("Please select at least one primary contact.");
      } else {
        message.error("Only one primary contact can be selected.");
      }
    }
  };

  const LinkCouriers = (model) => {
    setIsFormValid(true);
    showSpin();
    LinkSettingsCourierAccount(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data.is_success) {
            message.success(data?.data?.message);
            navigate("/settings/couriers");
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  // const SubmitContacts = (model) => {
  //     setIsFormValid(true);
  //     showSpin()
  //     SubmitCourierContacts(token, model)
  //         .then((res) => {
  //             const data = res?.data || null;
  //             if (data) {
  //                 if (data?.data.is_success) {
  //                     message.success(data?.data?.message);
  //                     setIsEnabled(false);
  //                     navigate("/settings/couriers")
  //                 } else {
  //                     message.error(data?.data?.message);
  //                 }
  //             }
  //         })
  //         .catch((err) => {
  //             unauthorize(err);
  //         }).finally(() => {
  //             hideSpin();
  //             setIsFormValid(false);
  //         });
  // };

  const handleCancel = () => {
    let model = {
      courier_id: courierId,
      credentials: null,
      contacts: [],
    };
    LinkCouriers(model);
  };

  const onRemoveButtonClick = () => {
    if (id) {
      showSpin();
      DeleteSettingCouriers(id, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              form.resetFields();
              message.success(data?.data?.message);
              setStatus(null);
              setCourierName("");
              navigate("/settings/couriers/form");
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  return (
    <>
      <Flex justify="space-between" align="center" gap={25}>
        {id ? (
          <>
            <div className="custom-breadcrumbs">
              <Breadcrumb
                separator={courierName && `>`}
                items={[
                  {
                    title: <a>Transport providers</a>,
                    onClick: () => navigate("/settings/couriers"),
                  },
                  {
                    title: courierName ? capitalize(courierName) : "",
                  },
                ]}
              />
            </div>

            {status == "Problem with Connection" && (
              <CustomButton
                text={"Remove provider"}
                height="36px"
                fontSize="14px"
                fontWeight="500"
                lineHeight="16px"
                borderRadius="8px"
                bgColor="#F3F3F3"
                color="#DE1135"
                boxShadow="none"
                onClick={onRemoveButtonClick}
                iconPosition="left"
                gap={8}
                image={deleteRedIcon}
              />
            )}
          </>
        ) : (
          <CustomTitle
            text={"New Transport Provider"}
            fontSize={24}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        )}
      </Flex>

      {id && status == "Problem with Connection" && (
        <StatusCardNotification
          cardStyle={"style-1"}
          icon={<WarningFilled />}
          title={"Problem with connection"}
          description={
            "We're unable to reach your data from United Airlines. Please try relinking your connection."
          }
          bgColor="#F6BC2F"
          actionButtonText={"Relink"}
          actionButtonWidth="112px"
          actionButtonBorderRadius="8px"
          actionButtonBgColor="#FBE5B6"
          actionButtonOnClick={() => console.log("Relink")}
        />
      )}

      <div>
        <CustomTitle
          text={"Instructions"}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />
        {instructions && (
          <p
            style={{
              fontSize: "14px",
              lineHeight: "24px",
              marginBottom: "0px",
            }}
            dangerouslySetInnerHTML={{
              __html: instructions,
            }}
          ></p>
        )}
      </div>

      <Form
        form={form}
        name="validateOnly"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Flex vertical={true} gap={32}>
          <Flex vertical={true} gap={20}>
            <Flex gap={16} wrap="wrap">
              {/* <Form.Item
                                className="custom-input"
                                label="Transport Provider"
                                name="courier_id"
                                rules={[
                                    { required: true, message: "Please select name" }
                                ]}
                                style={{ marginBottom: "0px" }}
                            >
                                <CustomDynamicSelect
                                    placeholder="Select"
                                    width="200px"
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    options={couriersDDL}
                                    disabled={!!id}
                                    label="title"
                                />
    */}
              {showErrorMessage && (
                <p
                  style={{
                    color: "#5E5E5E",
                    fontSize: 14,
                    whiteSpace: "nowrap",
                    marginBottom: 0,
                    marginTop: "20px",
                  }}
                >
                  Integration in progress,a zoomlogi provider will contact you.
                </p>
              )}

              {/* </Form.Item> */}

              {isEnabled && (
                <>
                  {/* <Form.Item
                    className="custom-input"
                    label="Client ID"
                    name="client_id"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      // { type: "email", message: "Enter valid email" },
                    ]}
                    style={{ marginBottom: "0px" }}
                  >
                    <CustomInput
                      placeholder="Enter client id"
                      height="36px"
                      width={200}
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#5E5E5E"
                      borderRadius="8px"
                      placeholderColor="#5E5E5E"
                      lineHeight="38px"
                    />
                  </Form.Item> */}

                  {/* <Form.Item
                    className="custom-input"
                    label="Client Secret"
                    name="client_secret"
                    rules={[
                      { required: true, message: "Please enter your password" },
                      // { type: "password", message: "Please enter a valid password!" },
                      // { type: "string", min: 6, message: "Password must be at least 6 characters long." },
                      // { type: "string", max: 20, message: "Password cannot exceed 20 characters." },
                    ]}
                  >
                    <CustomInput
                      placeholder="Enter client secret"
                      height="36px"
                      width={200}
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#5E5E5E"
                      borderRadius="8px"
                      placeholderColor="#5E5E5E"
                      lineHeight="38px"
                      type="password"
                    />
                  </Form.Item> */}
                  {courierModal.map((element) => (
                    <Form.Item
                      label={element}
                      name={element}
                      className="custom-form-item"
                      style={{ paddingTop: "12px" }}
                      rules={[
                        {
                          required: true,
                          message: `Please input ${
                            element ? element : "value"
                          }`,
                        },
                      ]}
                    >
                      <CustomInput
                        placeholder={`Paste ${
                          element ? element : "value"
                        } here`}
                        height="36px"
                        width="100%"
                        border="0px"
                        bgColor="#F3F3F3"
                        textColor="#5E5E5E"
                        borderRadius="8px"
                        placeholderColor="#5E5E5E"
                        lineHeight="38px"
                        // suffix={<img src={shield} alt="shield" />}
                      />
                    </Form.Item>
                  ))}
                </>
              )}
            </Flex>
          </Flex>

          {/* <CustomButton
                        text="Link"
                        width={138}
                        height={36}
                        borderRadius={8}
                        bgColor="#000"
                        color="#fff"
                        border="0px"
                        fontSize={14}
                        fontWeight={500}
                        htmlType='submit'
                        isFormValid={isFormValid}
                    /> */}
        </Flex>
        <Row style={{ width: "100%", marginTop: "20px" }}>
          <CustomTitle
            text={"Contacts"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
          <div style={{ width: "100%", marginTop: "25px" }}>
            <Form.List
              name="contacts"
              initialValue={[
                {
                  name: "",
                  role: "",
                  email: "",
                  country_code: "",
                  phone_number: "",
                  is_primary_contact: false,
                },
              ]} // Initial single entry
            >
              {(fields, { add, remove }) => (
                <Row style={{ width: "100%" }}>
                  <Row style={{ gap: "16px", width: "100%" }}>
                    <>
                      {fields.map((field, index) => (
                        <>
                          <div
                            style={{
                              width: "100%",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <Row
                              gutter={[16, 16]}
                              style={{ width: "100%" }}
                              key={index}
                            >
                              <Col
                                xxl={5}
                                xl={5}
                                lg={12}
                                md={16}
                                sm={24}
                                xs={24}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={
                                    index === 0 ? (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                        }}
                                      >
                                        Name
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  }
                                  name={[index, "name"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter contact name",
                                    },
                                  ]}
                                  style={{ marginBottom: "6px" }}
                                >
                                  <CustomInput
                                    placeholder="Enter name"
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    placeholderColor="#5E5E5E"
                                    lineHeight="38px"
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                xxl={5}
                                xl={5}
                                lg={12}
                                md={16}
                                sm={24}
                                xs={24}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={
                                    index === 0 ? (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                        }}
                                      >
                                        Role
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  }
                                  name={[index, "role"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter role",
                                    },
                                  ]}
                                  style={{ marginBottom: "6px" }}
                                >
                                  <CustomInput
                                    placeholder="Enter role"
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    placeholderColor="#5E5E5E"
                                    lineHeight="38px"
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                xxl={5}
                                xl={5}
                                lg={12}
                                md={16}
                                sm={24}
                                xs={24}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={
                                    index === 0 ? (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                        }}
                                      >
                                        Email
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  }
                                  name={[index, "email"]}
                                  style={{ marginBottom: "6px" }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter  email",
                                    },
                                    {
                                      type: "email",
                                      message: "Enter valid email",
                                    },
                                  ]}
                                >
                                  <CustomInput
                                    placeholder="Enter email"
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    placeholderColor="#5E5E5E"
                                    lineHeight="38px"
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                xxl={5}
                                xl={5}
                                lg={12}
                                md={16}
                                sm={24}
                                xs={24}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={
                                    index === 0 ? (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                        }}
                                      >
                                        Phone
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  }
                                  style={{ marginBottom: "8px" }}
                                >
                                  <Flex gap={10}>
                                    <Form.Item
                                      className="custom-form-item"
                                      name={[index, "phone_number"]}
                                      style={{ marginBottom: "0" }}
                                    >
                                      <div style={{ width: "100%" }}>
                                        {/* <ReactFlagsSelect
                                          selected={form.getFieldValue([
                                            "contacts",
                                            index,
                                            "country_code",
                                          ])} // Correct way to fetch value
                                          onSelect={(code) => {
                                            handleSelect(code, index);
                                          }}
                                          customLabels={countryOptions}
                                          placeholder="Country code"
                                          showSelectedLabel={false}
                                          selectedSize={10}
                                          optionsSize={10}
                                        /> */}

                                        <PhoneInput
                                          country={"us"}
                                          value={form.getFieldValue([
                                            "contacts",
                                            index,
                                            "phone_number",
                                          ])}
                                          onChange={(
                                            value,
                                            countryData,
                                            e,
                                            formattedValue
                                          ) =>
                                            handleSelect(formattedValue, index)
                                          }
                                        />
                                      </div>
                                    </Form.Item>

                                    {/* <Form.Item
                                      name={[index, "phone_number"]}
                                      style={{ marginBottom: "0" }}
                                      // rules={[
                                      //     { required: true, message: "Please enter phone number!" },
                                      // ]}
                                    >
                                      <CustomInput
                                        placeholder="Enter phone"
                                        height="36px"
                                        border="0px"
                                        bgColor="#F3F3F3"
                                        textColor="#5E5E5E"
                                        borderRadius="8px"
                                        placeholderColor="#5E5E5E"
                                        lineHeight="38px"
                                      />
                                    </Form.Item> */}
                                  </Flex>
                                </Form.Item>
                              </Col>
                              <Col
                                xxl={3}
                                xl={3}
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={
                                    index === 0 ? (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#666",
                                        }}
                                      >
                                        Primary contact?
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  }
                                  name={[index, "is_primary_contact"]}
                                  valuePropName="checked"
                                  //rules={[{ required: true, message: "Please select if this is the primary contact" }]}
                                  style={{
                                    marginBottom: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Checkbox style={{ marginRight: "40px" }} />
                                </Form.Item>
                              </Col>
                              <Col
                                xxl={1}
                                xl={1}
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{ marginBottom: "16px" }}
                              >
                                <Form.Item
                                  label={"action"}
                                  name={[index, "action"]}
                                  style={{
                                    marginBottom: "0",
                                    textAlign: "center",
                                  }}
                                  labelCol={{
                                    style: {
                                      display: index === 0 ? "auto" : "none",
                                      visibility: "hidden",
                                    },
                                  }}
                                >
                                  <CloseOutlined
                                    onClick={() => remove(index)}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </>
                      ))}
                    </>
                  </Row>

                  <Col
                    span={18}
                    offset={0}
                    className="info-div-add remove-margin-xs"
                  >
                    {/* Hide this button if you want to prevent adding new items */}
                    <AddItemButton
                      text="Add Another"
                      onClick={() =>
                        add({
                          name: "",
                          role: "",
                          email: "",
                          country_code: "",
                          phone_number: "",
                          is_primary_contact: false, // Explicitly set default value
                        })
                      }
                    />
                  </Col>
                </Row>
              )}
            </Form.List>
          </div>
        </Row>

        <div
          className="transport-form-btns"
          style={{
            marginTop: "30px",
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <CustomButton
            text={isEnabled ? "Link" : "Save"}
            width={138}
            height={36}
            borderRadius={8}
            bgColor="#000"
            color="#fff"
            border="0px"
            fontSize={14}
            fontWeight={500}
            htmlType="submit"
            isFormValid={isFormValid}
          />
          <CustomButton
            key="button1"
            onClick={handleCancel}
            text={"I’m okay with basic tracking"}
            bgColor={"#F3F3F3"}
            color="black"
            fontSize="14px"
            fontWeight="500"
            boxShadow="none"
            height="40px"
          />
        </div>
      </Form>
    </>
  );
};

export default SettingsTransportForm;
